import React from "react";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const MealResponseChart = ({ summary }) => {
    const data = {
        labels: ["Breakfast", "Lunch", "Snacks", "Dinner"],

        datasets: [
            {
                label: "Opt-In",
                data: [
                    summary?.breakfastOptIn ?? 0,
                    summary?.lunchOptIn ?? 0,
                    summary?.snacksOptIn ?? 0,
                    summary?.dinnerOptIn ?? 0,
                ],
                backgroundColor: "#22c55e",
                borderRadius: 5,
            },
            {
                label: "Opt-Out",
                data: [
                    summary?.breakfastServed ?? 0,
                    summary?.lunchServed ?? 0,
                    summary?.snacksServed ?? 0,
                    summary?.dinnerServed ?? 0,
                ],
                backgroundColor: "#ef4444",
                borderRadius: 5,
            },
            {
                label: "Not Responded",
                data: [
                    summary?.breakfastNotResponded ?? 0,
                    summary?.lunchNotResponded ?? 0,
                    summary?.snacksNotResponded ?? 0,
                    summary?.dinnerNotResponded ?? 0,
                ],
                backgroundColor: "#94a3b8",
                borderRadius: 5,
            },
        ],
    };

    const maxResidents = Math.max(
        summary?.breakfastOptIn ?? 0,
        summary?.breakfastServed ?? 0,
        summary?.breakfastNotResponded ?? 0,
        summary?.lunchOptIn ?? 0,
        summary?.lunchServed ?? 0,
        summary?.lunchNotResponded ?? 0,
        summary?.snackOptIn ?? 0,
        summary?.snackServed ?? 0,
        summary?.snackNotResponded ?? 0,
        summary?.dinnerOptIn ?? 0,
        summary?.dinnerServed ?? 0,
        summary?.dinnerNotResponded ?? 0
    );

    const yAxisMax = Math.max(5, Math.ceil(maxResidents * 1.2));

    const options = {
        responsive: true,
        maintainAspectRatio: false,

        plugins: {
            legend: {
                position: "bottom",
            },

            title: {
                display: false,
                text: "Meal Response Overview",
                font: {
                    size: 18,
                    weight: "600",
                },
            },

            tooltip: {
                mode: "index",
                intersect: false,
            },
        },

        scales: {
            x: {
                stacked: false,
                grid: {
                    display: false,
                },
            },

            y: {
                beginAtZero: true,
                max: yAxisMax,
                ticks: {
                    stepSize: 10,
                },

                title: {
                    display: true,
                    text: "Number of Residents",
                },
            },
        },
    };

    return (
        <div className="bg-white rounded-xl border border-gray-100 px-4 py-4">
            <div className="flex justify-between items-center mb-4">
                <div>
                    <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
                        Meal Response Overview
                    </h3>
                </div>
            </div>
            <div
                style={{
                    width: "100%",
                    height: "400px",
                    padding: "20px",
                    background: "#fff",
                    borderRadius: "12px",
                }}
            >
                <Bar data={data} options={options} />
            </div>
        </div>
    );
};

export default MealResponseChart;